import revtrax from './code/Scripts/Components/revtrax.vue';

export default {
  components: {
    revtrax,
  },
};
